<template>
  <Transition name="banner">
    <div v-if="pending" ref="bannerEl" class="cookie-banner">
      <div class="cookie-banner-inner">
        <p class="cookie-banner-text">
          Nous utilisons des cookies analytiques pour mesurer la fréquentation
          de ce site. Ces données ne sont pas utilisées à des fins
          publicitaires.
          <NuxtLink to="/confidentialite" class="cookie-banner-link"
            >En savoir plus</NuxtLink
          >
        </p>
        <div class="cookie-banner-actions">
          <button class="btn" @click="decline">Refuser</button>
          <button class="btn btn-primary" @click="accept">Accepter</button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const { pending, accept, decline } = useCookieConsent();

const bannerEl = ref<HTMLElement>();

const ro = import.meta.client
  ? new ResizeObserver(([entry]) => {
      if (!entry) return;
      document.documentElement.style.setProperty(
        '--cookie-banner-height',
        `${entry.contentRect.height}px`,
      );
    })
  : null;

watch(bannerEl, (el) => {
  if (el) ro?.observe(el);
  else {
    ro?.disconnect();
    document.documentElement.style.removeProperty('--cookie-banner-height');
  }
});
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  background: var(--card);
  border-top: 1px solid var(--line);
}

.cookie-banner-inner {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 16px 40px;
  flex-wrap: wrap;
}

.cookie-banner-text {
  flex: 1;
  min-width: 200px;
  font-size: 12px;
  line-height: 1.6;
  color: var(--ink-dim);
}

.cookie-banner-link {
  color: var(--ink);
  text-decoration: underline;
  text-underline-offset: 3px;
  white-space: nowrap;
}

.cookie-banner-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.banner-enter-active,
.banner-leave-active {
  transition:
    transform 0.25s ease,
    opacity 0.25s ease;
}
.banner-enter-from,
.banner-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

@media (max-width: 768px) {
  .cookie-banner-inner {
    padding: 16px 20px 76px;
    gap: 16px;
  }
}
</style>
